import * as pedido from '@/api/pedido'

const state = {
  listTodos: [],
  filtros: { page: 1 },
  countPage: 0,
  loading: false,
  filaId: null
}

const mutations = {
  SETLEADSTODOS (state, payload) {
    state.listTodos = payload
  },
  SETFILTROS (state, payload) {
    if (payload) {
      state.filtros = payload
    }
  },
  SETPAGE (state, payload) {
    state.filtros.page = payload
  },
  SETPAGINATE (state, payload) {
    if (payload === 1) state.countPage = 0
    else state.countPage = payload
  },
  SETLOADING (state, payload) {
    state.loading = payload
  },
  SETFILAID (state, payload) {
    state.filaId = payload
  }
}

const actions = {
  async getLeadsTodos ({ commit }, payload) {
    commit('SETFILTROS', payload)
    let envelope = await pedido.getLeadsTodos(payload)
    let data = envelope.instancia
    commit('SETLEADSTODOS', data.list)
    commit('SETPAGINATE', data.pages)
  },
  async filaGetLeadsTodos ({ commit }, payload) {
    commit('SETFILTROS', payload)
    let envelope = await pedido.filaGetLeadsTodos(payload)
    let data = envelope.instancia
    commit('SETLOADING', true)
    commit('SETFILAID', data)
  },
  setPage (context, payload) {
    context.commit('SETPAGE', payload)
  },
  setLoading ({ commit }, payload) {
    commit('SETLOADING', payload)
  },
  setLeadsTodos ({ commit }, payload) {
    commit('SETLEADSTODOS', payload.list)
    commit('SETPAGINATE', payload.pages)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/pedido/leads.js